VjsAdmin.MyBulkUploads = (function () {
    const me = {};

    const $table = $('#bulk-uploads-table');

    // quit polling the server if too many errors happen
    me.polling_error = 0;
    me.polling_error_threshold = 2;

    // amount of time between refreshing the table
    me.polling_interval = 4000;

    const init = function () {
        initBulkUploadsTable();
    };

    const initBulkUploadsTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#bulk-uploads-table',
            formatNoMatches() {
                return 'No bulk uploads for you!';
            },
            onRefresh() {},
            onLoadError(status, res) {
                VjsTable.tableDefaults().onLoadError.call(this, status, res);
                // increment how many polling errors we've gotten
                me.polling_error++;

                // if we've had too many errors, don't schedule a refresh...
                if (me.polling_error <= me.polling_error_threshold) {
                    setTimeout(() => {
                        $table.bootstrapTable('refresh', { silent: true });
                    }, me.polling_interval);
                }
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);

                // since we had a success, reset polling errors to 0
                me.polling_error = 0;

                // refresh the table in a lil bit
                setTimeout(() => {
                    $table.bootstrapTable('refresh', { silent: true });
                }, me.polling_interval);
            },
            idField: 'bulk_upload_id',
            showRefresh: false,
            pagination: false,
            sidePagination: 'client',
            pageSize: 100,
            search: false,
            sortName: 'bulk_upload_id',
            url: `${window.location.href.split('#')[0]}json/`,
            columns: [
                {
                    title: 'Status',
                    field: 'status',
                    align: 'center',
                    valign: 'middle',
                    class: 'status',
                    sortable: false,
                },
                {
                    title: 'Type',
                    field: 'type',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Platform',
                    field: 'platform_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'By',
                    field: 'creator_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'District',
                    field: 'district_joint_guid',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'License',
                    field: 'license_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'File',
                    field: 'file_path',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa-regular fa-clock" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa-regular fa-clock" aria-hidden="true"></i> Started',
                    field: 'date_started',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa-regular fa-clock" aria-hidden="true"></i> Processed',
                    field: 'date_processed',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa fa-user" aria-hidden="true"></i> Total',
                    field: 'rows_total',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa fa-user" aria-hidden="true"></i> Processed',
                    field: 'rows_uploaded',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa fa-user" aria-hidden="true"></i> Failed',
                    field: 'rows_failed',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                let formattedResult = {};
                formattedResult = res.data.data;

                $(formattedResult).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const raw = JSON.parse(JSON.stringify(result));
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = ['date_created', 'date_started', 'date_processed'];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);
                    const { status } = row;
                    const rowsTotal = row.rows_total;
                    const rowsCreated = row.rows_created;
                    const rowsUpdated = row.rows_updated;
                    const rowsFailed = row.rows_failed;
                    const rowsSkipped = row.rows_skipped;
                    const rowsDeleted = row.rows_deleted;
                    const rowsProcessed = parseInt(rowsSkipped)
                        + parseInt(rowsDeleted)
                        + parseInt(rowsCreated)
                        + parseInt(rowsUpdated)
                        + parseInt(rowsFailed);
                    const rowsRemaining = rowsTotal - rowsProcessed;

                    // add the estimated time remaining
                    if (row.status === 'processing') {
                        const duration = moment(raw.date_last_action, 'MM/DD/YYYY HH:mm:ss').diff(
                            moment(raw.date_started, 'MM/DD/YYYY HH:mm:ss'),
                        );
                        const averageTimePerRow = duration / (rowsProcessed === 0 ? 1 : rowsProcessed) / 1000;
                        const estimatedSecondsRemaining = averageTimePerRow * rowsRemaining;
                        const estimatedTimeRemaining = moment().add(estimatedSecondsRemaining, 'seconds');
                        if (estimatedSecondsRemaining > 0) {
                            row.date_processed = `ESTIMATE:<br><em><time title='${estimatedTimeRemaining.format(
                                'MMMM Do YYYY, h:mm:ss a',
                            )}'>${estimatedTimeRemaining.fromNow()}</time></em>`;
                        }
                    }

                    row.status = `<strong>${row.status}</strong>`;
                    if (status === 'completed') {
                        if (row.rows_failed > 0) {
                            row.status
                                += ' <span class="text-danger">...with errors<i class="fa fa-exclamation-triangle" title="with errors" aria-hidden="true"></i></span>';
                        } else {
                            row.status += '<i class="fa fa-thumbs-up text-success" aria-hidden="true"></i>';
                        }
                    }
                    if (status === 'processing') {
                        row.status += ` - ${((rowsProcessed / parseInt(rowsTotal)) * 100).toFixed(2)}%`;
                    }

                    if (row.date_expired != null) {
                        row.status += '<i class="fa-regular fa-clock" aria-hidden="true"></i>';
                    }

                    row.creator_id = `${row.first_name} ${row.last_name}`;

                    if (row.file_path) {
                        if (row.date_expired != null) {
                            row.file_path = '<i class="fa-regular fa-file-excel" aria-hidden="true"></i>';
                        } else {
                            let fileUrl = '';
                            switch (row.type) {
                                case 'users':
                                    fileUrl = Slim.Router.pathFor('platforms.districts.licenses.users.bulkuploads.original_file.download', {
                                        platform_id: row.platform_id,
                                        district_joint_guid: row.district_joint_guid,
                                        license_id: row.license_id,
                                        bulk_upload_id: row.bulk_upload_id,
                                    });
                                    break;
                                case 'groups':
                                    fileUrl = Slim.Router.pathFor(
                                        'platforms.districts.licenses.groups.bulkuploads.original_file.download',
                                        {
                                            platform_id: row.platform_id,
                                            district_joint_guid: row.district_joint_guid,
                                            license_id: row.license_id,
                                            bulk_upload_id: row.bulk_upload_id,
                                        },
                                    );
                                    break;
                                case 'district-users':
                                    fileUrl = Slim.Router.pathFor('platforms.districts.users.bulkuploads.original_file.download', {
                                        platform_id: row.platform_id,
                                        district_joint_guid: row.district_joint_guid,
                                        bulk_upload_id: row.bulk_upload_id,
                                    });
                                    break;
                                default:
                                    break;
                            }
                            row.file_path = `<a href="${fileUrl}"><i class="fa-regular fa-file-excel" aria-hidden="true"></i></a>`;
                        }
                    }

                    if (row.rows_created < 0) {
                        row.rows_created = 0;
                    }

                    if (row.rows_updated < 0) {
                        row.rows_updated = 0;
                    }

                    if (row.rows_failed > 0) {
                        if (row.date_expired != null) {
                            row.rows_failed = `<span class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${row.rows_failed}</span>`;
                        } else {
                            let errorsUrl = '';
                            switch (row.type) {
                                case 'users':
                                    errorsUrl = Slim.Router.pathFor('platforms.districts.licenses.users.bulkuploads.errors.list', {
                                        platform_id: row.platform_id,
                                        district_joint_guid: row.district_joint_guid,
                                        license_id: row.license_id,
                                        bulk_upload_id: row.bulk_upload_id,
                                    });
                                    break;
                                case 'groups':
                                    errorsUrl = Slim.Router.pathFor('platforms.districts.licenses.groups.bulkuploads.errors.list', {
                                        platform_id: row.platform_id,
                                        district_joint_guid: row.district_joint_guid,
                                        license_id: row.license_id,
                                        bulk_upload_id: row.bulk_upload_id,
                                    });
                                    break;
                                case 'district-users':
                                    errorsUrl = Slim.Router.pathFor('platforms.districts.users.bulkuploads.errors.list', {
                                        platform_id: row.platform_id,
                                        district_joint_guid: row.district_joint_guid,
                                        bulk_upload_id: row.bulk_upload_id,
                                    });
                                    break;
                                default:
                                    break;
                            }
                            row.rows_failed = `<a href="${errorsUrl}" class="text-danger btn btn-hollow-pink"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${row.rows_failed}</a>`;
                        }
                    } else {
                        row.rows_failed = '<div class="text-success">0</div>';
                    }

                    // if(row.users_with_activity <= 0){ //only allow cancelling if no users in this bulk upload have logged in or done anything on the site
                    // only allow cancelling if it's not totally complete with all failures
                    if (+rowsTotal !== +rowsFailed && row.date_expired == null) {
                        const cancelUrl = Slim.Router.pathFor('platforms.districts.licenses.users.bulkuploads.cancel', {
                            platform_id: row.platform_id,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                            bulk_upload_id: row.bulk_upload_id,
                        });
                        // var undo_url = Slim.Router.pathFor('platforms.districts.licenses.users.bulkuploads.undo', {platform_id: row.platform_id, district_joint_guid: row.district_joint_guid, license_id: row.license_id, bulk_upload_id: row.bulk_upload_id});
                        switch (status) {
                            case 'processing':
                                if (rowsCreated > 0 || rowsUpdated > 0) {
                                    row.actions = `<form method="post" action="${cancelUrl}"><button type="submit" class="btn btn-hollow-pink">Stop</input></form>`;
                                } else {
                                    row.actions = `<form method="post" action="${cancelUrl}"><button type="submit" class="btn btn-hollow-pink">Cancel</input></form>`;
                                }
                                break;
                            case 'queued':
                                row.actions = `<form method="post" action="${cancelUrl}"><button type="submit" class="btn btn-hollow-pink">Cancel</input></form>`;
                                break;
                            case 'completed':
                                // row.actions = '<form method="get" action="'+undo_url+'"><button type="submit" class="btn btn-hollow-pink">Undo</input></form>';
                                break;
                            case 'cancelled':
                                if (rowsCreated > 0 || rowsUpdated > 0) {
                                    // row.actions = '<form method="get" action="'+undo_url+'"><button type="submit" class="btn btn-hollow-pink">Undo</input></form>';
                                }
                                break;
                            default:
                                break;
                        }
                    }

                    let detailsUrl = '';
                    switch (row.type) {
                        case 'users':
                            detailsUrl = Slim.Router.pathFor('platforms.districts.licenses.users.bulkuploads.list', {
                                platform_id: row.platform_id,
                                district_joint_guid: row.district_joint_guid,
                                license_id: row.license_id,
                            });
                            row.license_id = `<a href="${detailsUrl}">${row.license_id}</a>`;
                            break;
                        case 'groups':
                            detailsUrl = Slim.Router.pathFor('platforms.districts.licenses.groups.bulkuploads.list', {
                                platform_id: row.platform_id,
                                district_joint_guid: row.district_joint_guid,
                                license_id: row.license_id,
                            });
                            row.license_id = `<a href="${detailsUrl}">${row.license_id}</a>`;
                            break;
                        case 'district-users':
                            detailsUrl = Slim.Router.pathFor('platforms.districts.users.bulkuploads.list', {
                                platform_id: row.platform_id,
                                district_joint_guid: row.district_joint_guid,
                                license_id: row.license_id,
                            });
                            row.district_joint_guid = `<a href="${detailsUrl}">${row.district_joint_guid}</a>`;
                            break;
                        default:
                            break;
                    }

                    /* eslint-disable no-underscore-dangle */
                    row._data = {
                        status,
                        bulk_upload_id: row.bulk_upload_id,
                    };
                    if (row.date_expired != null) {
                        row._data.status = 'expired';
                    }
                    /* eslint-enable no-underscore-dangle */
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
